export enum SupportedIdentificationTypeEnum {
  CPF = 'CPF',
  CNPJ = 'CNPJ',
  RFC = 'RFC',
  DNI = 'DNI',
  NIT = 'NIT',
  RUT = 'RUT',
}
